module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom16.3d88bcb6.jpg";